
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4gSB2", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $6rDm4 = parcelRequire("6rDm4");


var $jB2jW = parcelRequire("jB2jW");


var $ilHsf = parcelRequire("ilHsf");


var $gIMcb = parcelRequire("gIMcb");


var $g9ZnD = parcelRequire("g9ZnD");


var $aOKgt = parcelRequire("aOKgt");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d2X3H = parcelRequire("d2X3H");


var $9DHhW = parcelRequire("9DHhW");


var $gAjKf = parcelRequire("gAjKf");


var $GTXrQ = parcelRequire("GTXrQ");


var $krYZG = parcelRequire("krYZG");

const $5d1d19a216439bbb$var$RenderMediaInline = ({ rendererAppearance: _rendererAppearance, clipboardAttrs: clipboardAttrs, collection: collectionName, eventHandlers: eventHandlers, identifier: identifier, fallbackMediaNameFetcher: fallbackMediaNameFetcher, ssr: ssr })=>{
    const [contextIdentifier, setContextIdentifier] = (0, $cozmU.useState)();
    const [fileState, setFileState] = (0, $cozmU.useState)();
    const mediaClient = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
    const contextIdentifierProvider = (0, $jB2jW.useProvider)('contextIdentifierProvider');
    const ssrMediaItem = (0, $cozmU.useMemo)(()=>ssr?.ssrMediaItems?.find((item)=>item.id === identifier.id), [
        ssr?.ssrMediaItems,
        identifier.id
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (contextIdentifierProvider) contextIdentifierProvider.then((resolvedContextID)=>{
            if (contextIdentifier !== resolvedContextID) setContextIdentifier(resolvedContextID);
        });
    }, [
        contextIdentifier,
        contextIdentifierProvider
    ]);
    const updateFileState = (0, $cozmU.useCallback)(async (id)=>{
        const options = {
            collectionName: collectionName
        };
        try {
            if (mediaClient) {
                const fileState = await mediaClient.file.getCurrentState(id, options);
                setFileState(fileState);
            }
        } catch (error) {
        // eslint-disable-line no-unused-vars
        // do not set state on error
        }
    }, [
        collectionName,
        mediaClient
    ]);
    (0, $cozmU.useEffect)(()=>{
        const { id: id } = identifier;
        const nodeIsInCache = id && (0, $d2X3H.mediaIdentifierMap).has(id);
        if (!nodeIsInCache) (0, $d2X3H.mediaIdentifierMap).set(identifier.id, {
            ...identifier,
            collectionName: collectionName
        });
        return ()=>{
            (0, $d2X3H.mediaIdentifierMap).delete(id);
        };
    }, [
        identifier,
        collectionName
    ]);
    (0, $cozmU.useEffect)(()=>{
        const { id: id } = clipboardAttrs;
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        id && updateFileState(id);
    }, [
        contextIdentifier,
        clipboardAttrs,
        updateFileState
    ]);
    /*
   * Only show the loading view if the media client is not ready
   * prevents calling the media API before the provider is ready
   */ if (!mediaClient) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aOKgt.MediaInlineCardLoadingView), {
        message: "",
        isSelected: false
    });
    const handleMediaInlineClick = (result)=>{
        if (eventHandlers?.media?.onClick) eventHandlers?.media?.onClick(result);
    };
    const shouldOpenMediaViewer = true;
    const shouldDisplayToolTip = true;
    const { id: id, collection: collection } = clipboardAttrs;
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...(0, $d2X3H.getClipboardAttrs)({
            id: id,
            collection: collection,
            contextIdentifierProvider: contextIdentifier,
            fileState: fileState
        }),
        "data-node-type": "mediaInline",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ilHsf.default), {
            identifier: identifier,
            onClick: handleMediaInlineClick,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            shouldDisplayToolTip: shouldDisplayToolTip,
            mediaClientConfig: mediaClient.mediaClientConfig,
            mediaViewerItems: Array.from((0, $d2X3H.mediaIdentifierMap).values()),
            fallbackMediaNameFetcher: fallbackMediaNameFetcher,
            ssrMediaItem: ssrMediaItem
        })
    }));
};
const $5d1d19a216439bbb$var$MediaInline = (props)=>{
    const { collection: collection, id: id, intl: intl, rendererAppearance: rendererAppearance, featureFlags: featureFlags, type: fileType, alt: alt, width: width, height: height, marks: marks, ssr: ssr, fallbackMediaNameFetcher: fallbackMediaNameFetcher } = props;
    const clipboardAttrs = {
        id: id,
        collection: collection
    };
    const identifier = {
        id: id,
        mediaItemType: 'file',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        collectionName: collection
    };
    const mediaClient = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (fileType === 'image') {
        const hasLinkMark = marks?.find((mark)=>mark.type.name === 'link');
        const borderMark = marks?.find((mark)=>mark?.type.name === 'border');
        const borderColor = borderMark?.attrs.color ?? '';
        const borderSize = borderMark?.attrs.size ?? 0;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gAjKf.ErrorBoundary), {
            component: (0, $GTXrQ.ACTION_SUBJECT).RENDERER,
            componentId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_INLINE_IMAGE,
            createAnalyticsEvent: createAnalyticsEvent,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6rDm4.MediaInlineImageCard), {
                mediaClient: ssr?.config ? (0, $g9ZnD.getMediaClient)(ssr.config) : mediaClient,
                identifier: identifier,
                alt: alt,
                width: width,
                height: height,
                ssr: ssr,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                border: {
                    borderSize: borderSize,
                    borderColor: borderColor
                },
                serializeDataAttrs: true,
                shouldOpenMediaViewer: !hasLinkMark
            })
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)($5d1d19a216439bbb$var$RenderMediaInline, {
        identifier: identifier,
        clipboardAttrs: clipboardAttrs,
        eventHandlers: props.eventHandlers,
        rendererAppearance: rendererAppearance,
        intl: intl,
        collection: collection,
        featureFlags: featureFlags,
        fallbackMediaNameFetcher: fallbackMediaNameFetcher,
        ssr: ssr
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $5d1d19a216439bbb$var$_default_1 = (0, $kSwu1.injectIntl)($5d1d19a216439bbb$var$MediaInline);
var $5d1d19a216439bbb$export$2e2bcd8739ae039 = $5d1d19a216439bbb$var$_default_1;
module.exports["default"] = $5d1d19a216439bbb$export$2e2bcd8739ae039;

});

parcelRegister("d2X3H", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $llqlc = parcelRequire("llqlc");


var $17wiG = parcelRequire("17wiG");

var $b9ay8 = parcelRequire("b9ay8");

var $3lbOc = parcelRequire("3lbOc");

var $7dgG0 = parcelRequire("7dgG0");


var $gIMcb = parcelRequire("gIMcb");


var $gckmL = parcelRequire("gckmL");


var $ieeJu = parcelRequire("ieeJu");


var $grAaA = parcelRequire("grAaA");


var $krYZG = parcelRequire("krYZG");

const $bf8bf3c349673acc$export$7da2d00ddd5627a6 = new Map();
const $bf8bf3c349673acc$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $llqlc.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $bf8bf3c349673acc$export$cfff5eb155a82d30 extends (0, $cozmU.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $bf8bf3c349673acc$export$7da2d00ddd5627a6.has(id) || url && $bf8bf3c349673acc$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $bf8bf3c349673acc$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $bf8bf3c349673acc$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $bf8bf3c349673acc$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $bf8bf3c349673acc$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $bf8bf3c349673acc$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        const Card = enableSyncMediaCard ? (0, $7dgG0.default) : (0, $17wiG.default);
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Card, {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($bf8bf3c349673acc$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false,
                onError: this.getMediaErrorHandler(),
                onPreviewRender: this.props.onPreviewRender
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId, mediaViewerExtensions: mediaViewerExtensions, fallbackMediaNameFetcher: fallbackMediaNameFetcher } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b9ay8.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        const Card = enableSyncMediaCard ? (0, $7dgG0.default) : (0, $17wiG.default);
        // Quick solution to disable lazy loading of images on PDF export pages in Confluence to remedy an issue with images never loading
        // More robust solution will be implemented as part of CCPDF-233 - Link: https://hello.jira.atlassian.cloud/browse/CCPDF-233
        const currentUrl = window.location.href;
        const shouldDisableLazyLoading = (0, $ieeJu.expValEquals)('platform_editor_disable_lazy_load_media', 'isEnabled', true) && currentUrl.includes('/wiki/pdf/spaces/');
        const ssrMediaItem = ssr?.ssrMediaItems?.find((item)=>item.id === id);
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...$bf8bf3c349673acc$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Card, {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile && !shouldDisableLazyLoading,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($bf8bf3c349673acc$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                // Optional SSR seed supplied by the host product. Undefined when absent,
                ssrMediaItem: ssrMediaItem,
                shouldHideTooltip: isMobile,
                mediaViewerExtensions: mediaViewerExtensions,
                fallbackMediaNameFetcher: fallbackMediaNameFetcher,
                onError: this.getMediaErrorHandler(),
                onPreviewRender: this.props.onPreviewRender
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {};
        this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch  {
            // do not set state on error
            }
        };
        this.onError = (reason)=>{
            const { nestedUnder: nestedUnder, rendererContext: rendererContext } = this.props;
            this.props.onError?.(reason);
            this.props.fireAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    reason: reason,
                    external: false,
                    ...nestedUnder ? {
                        nestedUnder: nestedUnder
                    } : {},
                    ...rendererContext?.nestedRendererType ? {
                        nestedRendererType: rendererContext.nestedRendererType
                    } : {}
                }
            });
        };
        this.onConsumerError = (reason)=>{
            this.props.onError?.(reason);
        };
        this.getMediaErrorHandler = ()=>{
            if ((0, $ieeJu.expValEquals)('platform_editor_media_error_analytics', 'isEnabled', true)) return this.onError;
            return this.props.onError ? this.onConsumerError : undefined;
        };
        this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lbOc.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        };
        /**
     * We want to call provided `eventHandlers.media.onClick` when it's provided,
     * but we also don't want to call it when it's a video and inline video player is enabled.
     * This is due to consumers normally process this onClick call by opening media viewer and
     * we don't want that to happened described above text.
     */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $bf8bf3c349673acc$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $bf8bf3c349673acc$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $grAaA.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)($bf8bf3c349673acc$export$cfff5eb155a82d30, {
                ...props,
                mediaClient: mediaClient,
                fireAnalyticsEvent: fireAnalyticsEvent
            });
        }
    });
};
const $bf8bf3c349673acc$export$a6543a2e3828db2c = (0, $gckmL.withImageLoader)($bf8bf3c349673acc$export$fae4803d1ca121c8);
module.exports["mediaIdentifierMap"] = $bf8bf3c349673acc$export$7da2d00ddd5627a6;
module.exports["getClipboardAttrs"] = $bf8bf3c349673acc$export$92bef806f5be5d7c;
module.exports["MediaCard"] = $bf8bf3c349673acc$export$a6543a2e3828db2c;

});

parcelRegister("b9ay8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i2F2p = parcelRequire("i2F2p");


var $1pEse = parcelRequire("1pEse");


var $8quKc = parcelRequire("8quKc");

class $f93eee37bb8b930a$export$f7f7efdefcc02999 extends (0, $cozmU.Component) {
    render() {
        const dimensions = (0, $8quKc.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
            dimensions: dimensions
        }, this.icon);
    }
    get icon() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i2F2p.ErrorIcon), null);
    }
}
module.exports["CardError"] = $f93eee37bb8b930a$export$f7f7efdefcc02999;

});

parcelRegister("i2F2p", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $lMGh1 = parcelRequire("lMGh1");


var $8wVjr = parcelRequire("8wVjr");

class $5ba3853c5b49285b$export$19bc16ee58e19b3d extends (0, $cozmU.Component) {
    render() {
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $8wVjr.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            color: "currentColor",
            label: "Error"
        })));
    }
}
module.exports["ErrorIcon"] = $5ba3853c5b49285b$export$19bc16ee58e19b3d;

});

parcelRegister("8wVjr", function(module, exports) {
function $e51ea86914477cf8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e51ea86914477cf8$export$8dcf6b831a37de79 = {
    name: "5taie3",
    styles: "display:flex;color:var(--ds-icon-warning, #E06C00)"
};
module.exports["errorIconWrapperStyles"] = $e51ea86914477cf8$export$8dcf6b831a37de79;

});

parcelRegister("7dgG0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a1L5E = parcelRequire("a1L5E");


var $gnpwR = parcelRequire("gnpwR");

const $0bca0e1e5876e8f0$var$CardSync = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "media-card-sync",
            mode: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnpwR.CardWithMediaClient), props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "media-card-sync",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnpwR.CardWithMediaClient), props));
};
var $0bca0e1e5876e8f0$export$2e2bcd8739ae039 = $0bca0e1e5876e8f0$var$CardSync;
module.exports["default"] = $0bca0e1e5876e8f0$export$2e2bcd8739ae039;

});

parcelRegister("2iGHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b090c2970a43735$export$2e2bcd8739ae039);
var $3b090c2970a43735$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("3vMGL", function(module, exports) {

var $5vwoh = parcelRequire("5vwoh");


var $bdgrV = parcelRequire("bdgrV");


var $a7dWT = parcelRequire("a7dWT");

const $a25ace4035d13584$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $bdgrV.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $a25ace4035d13584$export$ea56ca58f08ffa52;

});

parcelRegister("5vwoh", function(module, exports) {
const $f2dacbe0eea831b8$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $f2dacbe0eea831b8$export$dca0327c9b9c6498;

});

parcelRegister("bdgrV", function(module, exports) {

var $5vwoh = parcelRequire("5vwoh");


var $kGZoG = parcelRequire("kGZoG");


var $8w4cs = parcelRequire("8w4cs");


var $cafP2 = parcelRequire("cafP2");

const $8d32407758572e3f$var$INVALID_DATE = new Date(NaN);
const $8d32407758572e3f$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $8d32407758572e3f$var$INVARIANT_DATE = (0, $cafP2.toDate)($8d32407758572e3f$var$INVARIANT);
const $8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $8d32407758572e3f$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $8d32407758572e3f$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $8d32407758572e3f$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $8d32407758572e3f$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($8d32407758572e3f$var$INVARIANT_DATE);
    const shortDate = $8d32407758572e3f$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $8d32407758572e3f$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $8d32407758572e3f$var$stripExtras(date).match($8d32407758572e3f$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $8d32407758572e3f$var$INVALID_DATE;
        const dateParts = $8d32407758572e3f$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $8w4cs.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $kGZoG.isValid)(normalizedDate)) return $8d32407758572e3f$var$INVALID_DATE;
        return (0, $cafP2.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $8d32407758572e3f$export$cfa2ef2687faeda2;

});

parcelRegister("kGZoG", function(module, exports) {

var $aDvYS = parcelRequire("aDvYS");

const $8985e2fc067d563b$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $aDvYS.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $8985e2fc067d563b$export$1ea939691cdc45b8;

});

parcelRegister("aDvYS", function(module, exports) {

var $6NKSh = parcelRequire("6NKSh");

const $e96e8b0ab312aaba$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $6NKSh.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $e96e8b0ab312aaba$export$f645ddd439eb259d;

});

parcelRegister("6NKSh", function(module, exports) {
const $04f001925dc3d06f$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $04f001925dc3d06f$export$553d7fa8e3805fc0;

});

parcelRegister("8w4cs", function(module, exports) {

var $9tavx = parcelRequire("9tavx");

const $7e5174e81eb823af$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $9tavx.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $7e5174e81eb823af$export$fcc71269590ba0a8;

});

parcelRegister("9tavx", function(module, exports) {
const $4b828859bff16031$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $4b828859bff16031$export$abe96da78d4f59dd;

});

parcelRegister("cafP2", function(module, exports) {
const $70268879eaf1b092$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $70268879eaf1b092$export$e67a095c620b86fe;

});

parcelRegister("a7dWT", function(module, exports) {
const $13d20959c22b69ba$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $13d20959c22b69ba$export$9b7ca29af37c192;

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("1tBud", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2mOOd = parcelRequire("2mOOd");


var $717N0 = parcelRequire("717N0");


const $4cc16dba49469f3f$var$MediaViewer = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("2hLNS")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
const $4cc16dba49469f3f$var$AsyncMediaViewer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AsyncMediaViewer(props) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function AsyncMediaViewer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
};
var $4cc16dba49469f3f$export$2e2bcd8739ae039 = $4cc16dba49469f3f$var$AsyncMediaViewer;
module.exports["default"] = $4cc16dba49469f3f$export$2e2bcd8739ae039;

});

parcelRegister("2mOOd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $imqjG = parcelRequire("imqjG");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $6ffa2f80eb372db6$export$442b7be89436c101 = '#101214';
const $6ffa2f80eb372db6$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t0 = colorMode !== "dark";
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
            blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
            invertSpinnerColor: t0
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
        blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $6ffa2f80eb372db6$export$2e2bcd8739ae039 = $6ffa2f80eb372db6$var$ModalSpinner;
module.exports["default"] = $6ffa2f80eb372db6$export$2e2bcd8739ae039;

});

parcelRegister("imqjG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $knkYU = parcelRequire("knkYU");

const $75f640d6e866ba35$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
var $75f640d6e866ba35$export$2e2bcd8739ae039 = $75f640d6e866ba35$var$ModalSpinner;
module.exports["default"] = $75f640d6e866ba35$export$2e2bcd8739ae039;

});

parcelRegister("knkYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea0f137a8e557bc$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $1ea0f137a8e557bc$var$blanketStyles = null;
const $1ea0f137a8e557bc$var$spinnerStyles = null;
const $1ea0f137a8e557bc$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $1ea0f137a8e557bc$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: blankedColor || $1ea0f137a8e557bc$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _2IhTondnbC _3OE6xYdnbC _0Bm75GdnbC _4ApkO2dnbC _42Yu6BEvR7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        appearance: invertSpinnerColor || $1ea0f137a8e557bc$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("717N0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cK21K = parcelRequire("cK21K");

const $60b53ae22e9372b5$export$51aee4c01b17acde = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
            zIndex: 510
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 510
    }, children);
module.exports["MediaViewerPortal"] = $60b53ae22e9372b5$export$51aee4c01b17acde;

});

parcelRegister("2hLNS", function(module, exports) {

let $1aa24019d185538c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1aa24019d185538c$var$load("4KIrO"),
    $1aa24019d185538c$var$load("Lm7SH"),
    $1aa24019d185538c$var$load("6OMo6"),
    $1aa24019d185538c$var$load("aaRXj"),
    $1aa24019d185538c$var$load("fHlIz"),
    $1aa24019d185538c$var$load("4QwAJ"),
    $1aa24019d185538c$var$load("3i44s"),
    $1aa24019d185538c$var$load("5kI0b"),
    $1aa24019d185538c$var$load("kYkz1"),
    $1aa24019d185538c$var$load("jfYeU"),
    $1aa24019d185538c$var$load("b4nm1"),
    $1aa24019d185538c$var$load("geXPZ"),
    $1aa24019d185538c$var$load("aQ5uu"),
    $1aa24019d185538c$var$load("6wr18"),
    $1aa24019d185538c$var$load("1xeJ3"),
    $1aa24019d185538c$var$load("60PUI"),
    $1aa24019d185538c$var$load("9ZyXP"),
    $1aa24019d185538c$var$load("iiagb"),
    $1aa24019d185538c$var$load("kHnae"),
    $1aa24019d185538c$var$load("42SV3"),
    $1aa24019d185538c$var$load("ffEVr"),
    $1aa24019d185538c$var$load("jTOhL"),
    $1aa24019d185538c$var$load("jOE2W"),
    $1aa24019d185538c$var$load("cuNBo"),
    $1aa24019d185538c$var$load("4Ldt2"),
    $1aa24019d185538c$var$load("2XRLb"),
    $1aa24019d185538c$var$load("gkVge"),
    $1aa24019d185538c$var$load("io0qR"),
    $1aa24019d185538c$var$load("3MJxZ"),
    $1aa24019d185538c$var$load("kHMR7"),
    $1aa24019d185538c$var$load("e3OZZ"),
    $1aa24019d185538c$var$load("cL682"),
    $1aa24019d185538c$var$load("4MePG"),
    $1aa24019d185538c$var$load("5JWJI"),
    $1aa24019d185538c$var$load("hhss7"),
    $1aa24019d185538c$var$load("4jXCC")
]).then(()=>parcelRequire('9vMzD'));

});

parcelRegister("4fGOw", function(module, exports) {

var $jx5V5 = parcelRequire("jx5V5");


var $lNvN4 = parcelRequire("lNvN4");

const $dc2272ad9447ddc9$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $jx5V5.useStore)(store, selector, equals);
function $dc2272ad9447ddc9$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $dc2272ad9447ddc9$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $dc2272ad9447ddc9$export$8a9cc8c330400af8;

});

parcelRegister("jx5V5", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $e385b0e7bfdc7f87$export$6ccbb43953eebf8);

var $3xeSM = parcelRequire("3xeSM");


var $cozmU = parcelRequire("cozmU");


var $aSzLn = parcelRequire("aSzLn");

var $e385b0e7bfdc7f87$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $e385b0e7bfdc7f87$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
const { useSyncExternalStoreWithSelector: $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($aSzLn)));
let $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = false;
const $e385b0e7bfdc7f87$var$identity = (arg)=>arg;
function $e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector = $e385b0e7bfdc7f87$var$identity, equalityFn) {
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$e385b0e7bfdc7f87$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = true;
    }
    const slice = $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $e385b0e7bfdc7f87$var$useDebugValue(slice);
    return slice;
}
const $e385b0e7bfdc7f87$var$createImpl = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $3xeSM.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $e385b0e7bfdc7f87$export$185802fd694ee1f5 = (createState)=>createState ? $e385b0e7bfdc7f87$var$createImpl(createState) : $e385b0e7bfdc7f87$var$createImpl;
var $e385b0e7bfdc7f87$export$2e2bcd8739ae039 = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $e385b0e7bfdc7f87$export$185802fd694ee1f5(createState);
};

});

parcelRegister("cvZVo", function(module, exports) {
const $b878f2b45b924d24$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
module.exports["isImageRepresentationReady"] = $b878f2b45b924d24$export$4e33ccde53b4f0bf;

});


//# sourceMappingURL=mediaInline.993404d5.js.map
